import React, { FC, ReactElement } from 'react';
import { chunk } from 'lodash';
import { toFixed } from 'humanize-plus';

import { StyleProps } from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import { Fundamental, Maybe } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/IdeaShowPage/RightSidebar/PositionInformation/positionInformationStyles.scss';

const MultiplesRatios: FC<StyleProps & {
  fundamental: Maybe<
    Pick<
      Fundamental,
      | 'currentPe'
      | 'debtBook'
      | 'divYield'
      | 'evEbitda'
      | 'evFcf'
      | 'evSales'
      | 'fcfYield'
      | 'forwardPe'
      | 'priceBook'
    >
  >;
  optionalAsterisk: string;
}> = ({ dataStyle, labelStyle, fundamental, optionalAsterisk }): ReactElement => {
  const {
    currentPe,
    debtBook,
    divYield,
    evEbitda,
    evFcf,
    evSales,
    fcfYield,
    forwardPe,
    priceBook
  } = fundamental || {};

  return (
    <table className={styles.table}>
      <tbody>
        {chunk(
          [
            {
              label: 'LTM P/E',
              data: currentPe ? `${toFixed(currentPe, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'FORWARD P/E',
              data: forwardPe ? `${toFixed(forwardPe, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'EV/EBITDA',
              data: evEbitda ? `${toFixed(evEbitda, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'EV FCF',
              data: evFcf ? `${toFixed(evFcf, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'EV SALES',
              data: evSales ? `${toFixed(evSales, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'PRICE BOOK',
              data: priceBook ? `${toFixed(priceBook, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'FCF YIELD',
              data: fcfYield ? `${toFixed(fcfYield, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'DEBT BOOK',
              data: debtBook ? `${toFixed(debtBook, 2)}${optionalAsterisk}` : 'N/A'
            },
            {
              label: 'DIV YIELD',
              data: divYield ? `${toFixed(divYield, 2)}${optionalAsterisk}` : 'N/A'
            }
          ],
          2
        ).map(
          ([first, second], idx): ReactElement => (
            <tr key={idx}>
              <td>
                <div className={labelStyle}>{first.label}</div>
                <div className={dataStyle}>{first.data}</div>
              </td>
              {second && (
                <td>
                  <div className={labelStyle}>{second.label}</div>
                  <div className={dataStyle}>{second.data}</div>
                </td>
              )}
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export default MultiplesRatios;
